import { useTranslation } from 'react-i18next';

import {
  DecisionIQInfoBottomStyled,
  DecisionIQRowStyled,
  DecisionIQInformationContainerStyled,
  PurpleLine,
  LightbulbAnimationStyled,
} from '../../DecisionIQStyled';
import { Spacer } from 'theSource/components';
import decIQLightbulb from 'enrollment/assets/DecIQLightbulb.svg';
import { InfoDrawer } from './InfoDrawer';
import './DecisionIQInformation.css';

export const DecisionIQInformation = () => {
  const { t } = useTranslation('pages.decisionIQ');

  return (
    <div className="row mx-0" data-testid="decision-iq-info-page">
      <div className="col">
        <DecisionIQInformationContainerStyled>
          <DecisionIQRowStyled className="align-items-center">
            <LightbulbAnimationStyled
              src={decIQLightbulb}
              aria-hidden="true"
              role="presentation"
              className="ml-md-3 mr-2_5"
            />
            <div>
              <p className="body1">{t('info_subtitle')} </p>
              <DecisionIQRowStyled className="align-items-center">
                <p className="emphasis body1">
                  <span>{t('voluntary_benefit.decision_iq_text')}</span>&nbsp;
                  {t('here_to_help')}
                </p>
              </DecisionIQRowStyled>
            </div>
          </DecisionIQRowStyled>
          <Spacer height={4} />
          <PurpleLine />
          <Spacer height={4.5} />

          <DecisionIQInfoBottomStyled>
            <DecisionIQRowStyled>
              <p className="mb-0 body1">
                {t('meet_deciq')}
                <span className="semiBold">"{t('ppl_like_you')}"</span>
              </p>
            </DecisionIQRowStyled>
            <DecisionIQRowStyled>
              <p className="body1 mb-4">
                {t('deciq_leverages')}
                <span className="semiBold mb-0 ml-1">
                  {t('family_details')}
                </span>
                <span className="ml-1">{t('deciq_examines')}</span>
              </p>
            </DecisionIQRowStyled>
            <p className="body1">{t('think_of_deciq')}</p>
            <InfoDrawer />
          </DecisionIQInfoBottomStyled>
        </DecisionIQInformationContainerStyled>
      </div>
    </div>
  );
};
